import webpManifest from "./webpManifest.json";

/**
 * Утилиты авто-WebP (задача #11 «Оптимизация картинок по весу / WebP», task 4509).
 * Манифест генерится `scripts/generate-webp.js` (список локальных картинок, у которых есть webp-двойник).
 * Оригиналы остаются fallback'ом в `<picture>`; webp отдаём только в прод-сборке
 * (в `gatsby develop` webp-файлов может не быть — они gitignored).
 */

const WEBP_SET = new Set(webpManifest as string[]);
const RASTER_RE = /\.(png|jpe?g)$/i;

// gatsby build всегда идёт в NODE_ENV=production; в `gatsby develop` — development.
export const IS_PROD = process.env.NODE_ENV === "production";

/** url → webp-url, если оригинал есть в манифесте; иначе null. Слэш нормализуем для поиска. */
export const toWebpUrl = (url: string): string | null => {
  const clean = url.split("?")[0];
  if (!RASTER_RE.test(clean)) return null;
  // в манифесте пути с ведущим слэшем; в разметке бывает и без (напр. "cardOfDay/…")
  const key = clean.startsWith("/") ? clean : `/${clean}`;
  if (!WEBP_SET.has(key)) return null;
  // возвращаем в исходном формате (сохраняем слэш/без-слэша, как было в разметке)
  return clean.replace(RASTER_RE, ".webp");
};

/**
 * srcSet "a.png 2x, b.png 3x" → "a.webp 2x, b.webp 3x".
 * Возвращает null, если хотя бы один url не имеет webp (тогда webp-source не добавляем — не рискуем).
 */
export const toWebpSrcSet = (srcSet: string): string | null => {
  const parts = srcSet.split(",").map((s) =>
    s.trim()).filter(Boolean);
  if (!parts.length) return null;

  const converted = parts.map((part) => {
    const [url, ...descriptor] = part.split(/\s+/);
    const webp = toWebpUrl(url);
    return webp ? [webp, ...descriptor].join(" ") : null;
  });

  return converted.includes(null) ? null : converted.join(", ");
};
